'use strict';

var ChartFbcApplicabilityViewportService = function ChartFbcApplicabilityViewportService($filter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function calculateTickValues(xAxisValues) {
    if (xAxisValues && xAxisValues.length > 0) {
      var elementsQuantity = xAxisValues.length;
      var firstDate = xAxisValues[0];
      var lastDate = xAxisValues[elementsQuantity - 1];
      var halfOfTheMonth = 15;
      if (firstDate.month() === lastDate.month() && firstDate.year() === lastDate.year()) {
        var centerElementIndex = Math.round(elementsQuantity / 2) - 1;
        var centerElement = xAxisValues[centerElementIndex];
        return {
          tickValues: [centerElement],
          ticksVisibleValues: [rmMomentFormat(centerElement, 'MONTH_SHORT_YEAR')]
        };
      } else {
        var result = [];
        var ticksVisibleValues = [];
        var curYear = 0;
        if (firstDate.date() > halfOfTheMonth) {
          result.push(firstDate);
          ticksVisibleValues.push(rmMomentFormat(firstDate, 'MONTH_SHORT_YEAR'));
          curYear = firstDate.year();
        }
        for (var i = 0; i < elementsQuantity; i++) {
          var curElement = xAxisValues[i];
          if (curElement.date() === halfOfTheMonth) {
            result.push(curElement);
            if (curYear !== curElement.year() || elementsQuantity - i <= halfOfTheMonth + 1 && curElement.month() === lastDate.month()) {
              curYear = curElement.year();
              ticksVisibleValues.push(rmMomentFormat(curElement, 'MONTH_SHORT_YEAR'));
            } else {
              ticksVisibleValues.push(rmMomentFormat(curElement, 'MONTH'));
            }
          }
        }
        if (lastDate.date() < halfOfTheMonth) {
          result.push(lastDate);
          ticksVisibleValues.push(rmMomentFormat(lastDate, 'MONTH_SHORT_YEAR'));
        }
        return {
          tickValues: result,
          ticksVisibleValues: ticksVisibleValues
        };
      }
    }
    return [];
  }
  return {
    calculateTickValues: calculateTickValues
  };
};
ChartFbcApplicabilityViewportService.$inject = ['$filter'];
module.exports = ChartFbcApplicabilityViewportService;